export default function CouponForm({ form, onChange }) {
  const set = (field, value) => onChange({ ...form, [field]: value });

  return (
    <div className="form-grid">
      <div className="form-group">
        <label>Coupon Code *</label>
        <input
          className="input"
          value={form.code || ''}
          onChange={(e) => set('code', e.target.value.toUpperCase())}
          required
          placeholder="SAVE10"
        />
      </div>
      <div className="form-group">
        <label>Discount Type *</label>
        <select
          className="input"
          value={form.discountType || 'percentage'}
          onChange={(e) => set('discountType', e.target.value)}
        >
          <option value="percentage">Percentage (%)</option>
          <option value="fixed">Fixed Amount (₹)</option>
        </select>
      </div>
      <div className="form-group">
        <label>Discount Value *</label>
        <input
          type="number"
          className="input"
          min="0"
          step="0.01"
          value={form.discountValue ?? ''}
          onChange={(e) => set('discountValue', parseFloat(e.target.value) || 0)}
          required
        />
      </div>
      <div className="form-group">
        <label>Minimum Order Value (₹)</label>
        <input
          type="number"
          className="input"
          min="0"
          value={form.minOrderValue ?? 0}
          onChange={(e) => set('minOrderValue', parseFloat(e.target.value) || 0)}
        />
      </div>
      <div className="form-group">
        <label>Maximum Discount (₹)</label>
        <input
          type="number"
          className="input"
          min="0"
          value={form.maxDiscountAmount ?? ''}
          onChange={(e) =>
            set('maxDiscountAmount', e.target.value === '' ? '' : parseFloat(e.target.value))
          }
          placeholder="For percentage coupons only"
        />
      </div>
      <div className="form-group">
        <label>Expiry Date</label>
        <input
          type="datetime-local"
          className="input"
          value={form.expiresAt || ''}
          onChange={(e) => set('expiresAt', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Usage Limit</label>
        <input
          type="number"
          className="input"
          min="1"
          value={form.usageLimit ?? ''}
          onChange={(e) =>
            set('usageLimit', e.target.value === '' ? '' : parseInt(e.target.value, 10))
          }
          placeholder="Unlimited if empty"
        />
      </div>
      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            checked={form.isActive !== false}
            onChange={(e) => set('isActive', e.target.checked)}
          />
          Active
        </label>
      </div>
    </div>
  );
}

export const emptyCouponForm = {
  code: '',
  discountType: 'percentage',
  discountValue: '',
  minOrderValue: 0,
  maxDiscountAmount: '',
  expiresAt: '',
  usageLimit: '',
  isActive: true,
};

export function couponToForm(coupon) {
  if (!coupon) return { ...emptyCouponForm };
  let expiresAt = '';
  if (coupon.expiresAt) {
    const d = new Date(coupon.expiresAt);
    expiresAt = d.toISOString().slice(0, 16);
  }
  return {
    code: coupon.code || '',
    discountType: coupon.discountType || 'percentage',
    discountValue: coupon.discountValue ?? '',
    minOrderValue: coupon.minOrderValue ?? 0,
    maxDiscountAmount: coupon.maxDiscountAmount ?? '',
    expiresAt,
    usageLimit: coupon.usageLimit ?? '',
    isActive: coupon.isActive !== false,
  };
}

export function formToCouponPayload(form) {
  const payload = {
    code: form.code,
    discountType: form.discountType,
    discountValue: Number(form.discountValue),
    minOrderValue: Number(form.minOrderValue) || 0,
    isActive: form.isActive !== false,
  };
  if (form.maxDiscountAmount !== '' && form.maxDiscountAmount != null) {
    payload.maxDiscountAmount = Number(form.maxDiscountAmount);
  }
  if (form.usageLimit !== '' && form.usageLimit != null) {
    payload.usageLimit = Number(form.usageLimit);
  }
  if (form.expiresAt) {
    payload.expiresAt = new Date(form.expiresAt).toISOString();
  }
  return payload;
}
